import { Logo } from "../Logo/Logo";
import { Button } from "../buttons/Button/Button";
import goodFace from "../../images/icons/GoodfaceLogo.svg"
import "./footer.css";

export const Footer = () => {
  return (
    <div className="container">
      <div className="footer">
        <div className="footer-upper-section">
          <div>
            <div className="logo">
              <Logo />
            </div>
            <p className="description-medium">
              Ensuring safer harvests
              <br /> in an unsafer environment.
            </p>
          </div>
          <div className="company-data-wrapper">
            <div className="company-information">
              <div>
                <p className="body1">Company</p>
                <p className="button-text">ABOUT US</p>
                <p className="button-text">RESEARCH, NEWS & EVENTS</p>
                <p className="button-text">CAREER</p>
                <p className="button-text">CONTACTS</p>
              </div>
              <div>
                <p className="body1">Products</p>
                <p className="button-text">ORGANIC LINE</p>
                <p className="button-text">WUXAL</p>
                <p className="button-text">PERTIPLANT</p>
                <p className="button-text">UNIFERX</p>
              </div>
              <div>
                <p className="body1">Resources</p>
                <p className="button-text">CROP NUTRITION PROGRAMS</p>
                <p className="button-text">TRIAL RESULTS</p>
                <p className="button-text">INFORMATION MATERIALS</p>
              </div>
            </div>
            <div className="footer-contacts">
              <div>
                <p className="body1">Social media</p>
                <div>
                  <Button type="instagram" />
                  <Button type="facebook" />
                  <Button type="youtube" />
                </div>
              </div>
              <div>
                <p className="body1">Contacts</p>
                <a href="mailto:info@uniferx.com" className="button-text mail">
                  INFO@UNIFERX.COM
                </a>
                <a href="tel:+380443344700" className="button-text phone">
                  +38 044 33 44 700
                </a>
                <a href="#" className="button-text map-pin">
                  81 TURGENEVSKA St., KYIV, OFFICE. 1-А
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-lower-section">
          <p className="body1 copyright">Copyright © UniferX 2023</p>
          <div className="policies">
            <p className="button-text">TERMS & CONDITIONS</p>
            <p className="button-text">LEGAL INFO</p>
            <p className="button-text">COOKIE POLICY</p>
            <p className="button-text">ANONYMOUS FEEDBACK</p>
          </div>
          <p>
            <span className="body1">Created by</span>{" "}
            <span className="goodface">
              <a href="https://goodface.agency" target="blank">
                Goodface
                <img src={goodFace} alt="Goodface logo" />
              </a>
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};
